<template>
    <div class="container-fluid">
        <div class="card card-default custom-card-height">
            <div class="card-header feature-header">
                <div class="row g-2">
                    <div class="col-auto me-auto">
                        <CardTitleComponent />
                    </div>
                    <div class="col-auto">
                        <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
                    </div>
                    <div class="col-auto">
                        <SubscriptionCommonComponent v-if="isHost()" @on-subscription="onSubscriptionChange" />
                    </div>
                    <div class="col-auto">
                        <a class="btn btn-outline-primary" @click="open(true)">
                            <i class="fas fa-plus me-1"></i>{{ $t('addNew') }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="card-body p-2">
                <div class="card-body-grid">
                    <ejs-grid ref="gridUser" :dataSource="data" :allowPaging="true" :allowResizing='true'
                        :pageSettings='pageSettings' :locale='locale' :rowHeight='38' height="100%" :allowSorting='true'
                        :searchSettings='searchOptions' :dataStateChange='dataStateChange'>
                        <e-columns>
                            <e-column v-if="isHost()" :headerText="$t('organization')"
                                field='Subscription.OrganizationName'></e-column>
                            <e-column :headerText="$t('firstName')" field='FirstName'></e-column>
                            <e-column :headerText="$t('lastName')" field='LastName'></e-column>
                            <e-column :headerText="$t('displayName')" field='DisplayName'></e-column>
                            <e-column :headerText="$t('email')" field='Email'></e-column>
                            <e-column :headerText="$t('role')" field='roleName' :allowSorting="false"></e-column>
                            <e-column :headerText="$t('actions')" width="75" textAlign="Center" :template="'actionTemplate'">
                                <template v-slot:actionTemplate="{ data }">
                                    <div class="btn-group actions-row" role="group" aria-label="Basic example">
                                        <a href="javascript:void(0)" class="ms-2 action-link action-edit" title="Edit"
                                            @click="commandClick('Edit', data)">
                                            <i class="e-edit e-icons" style="font-size: 0.76em;"></i>
                                        </a>
                                        <a href="javascript:void(0)" class="ms-2 action-link action-delete" title="Delete"
                                            @click="commandClick('Delete', data)">
                                            <i class="e-delete e-icons" style="font-size: 0.76em;"></i>
                                        </a>
                                    </div>
                                </template>
                            </e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
            <!-- /.card-body -->
        </div>
    </div>
    <div class="modal fade" id="userModal" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ $t('user') }}</h4>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" @click="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit="onUpsert">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col">
                                <div class="form-group mt-2 d-flex align-items-center gap-2" style="border-bottom: 1px solid #ced4da; margin-bottom: 12px; padding-bottom: 10px;">
                                    <input :disabled="isUpdate" type="checkbox" id="isADUser" class="checkbox"
                                        v-model="form.isADUser" @change="onADUserChange">
                                    <label for="isADUser" class="mb-0">{{ $t('microsoftEntraUser') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('customer') }} <span class="text-danger">*</span></label>
                                    <ejs-dropdownlist id='customerTree' v-model="form.subscriptionId"
                                        :dataSource='listSubscription' :fields='fieldsSubscription'
                                        :placeholder='$t("msgSelectCustomer")' @select="onSelectCustomer">
                                    </ejs-dropdownlist>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('role') }} <span class="text-danger">*</span></label>
                                    <ejs-dropdownlist id='roleTree' v-model="form.roleId" :dataSource='listRole'
                                        :fields='fieldsRole' :placeholder='$t("msgSelectRole")'>
                                    </ejs-dropdownlist>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{ $t('first') + ' ' + $t('name') }} <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control input-sm" v-model="form.firstName" required
                                        @input="onNameChange" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{ $t('last') + ' ' + $t('name') }} <span
                                            class="text-danger">*</span></label>
                                    <input type="text" class="form-control input-sm" v-model="form.lastName" required
                                        @input="onNameChange" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>{{ $t('displayName') }} <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control input-sm" v-model="form.displayName"
                                        required />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" v-if="form.isADUser">
                                <div class="form-group">
                                    <label>
                                        {{ $t('user') }} {{ $t('principleName') }}
                                        <span class="text-danger">* </span>
                                    </label>
                                    <input type="email" class="form-control input-sm" v-model="form.principleName"
                                        :disabled="isUpdate" required @input="principleNameInput()" />
                                </div>
                            </div>
                            <div class="col">
                                <div class="form-group">
                                    <label>{{ $t('email') }} <span class="text-danger">*</span></label>
                                    <input type="email" class="form-control input-sm" v-model="form.email"
                                        :disabled="isUpdate || (form.isADUser && form.driveFromPrincipleName)"
                                        required />
                                </div>
                            </div>
                            <div class="col" v-if="!isUpdate && !form.isADUser">
                                <div class="form-group">
                                    <label>{{ $t('password') }} <span class="text-danger">*</span></label>
                                    <input type="password" class="form-control input-sm" v-model="form.password"
                                        required />
                                </div>
                            </div>
                            <div class="col" v-if="!isUpdate && !form.isADUser">
                                <div class="form-group">
                                    <label>{{ $t('confirmPassword') }} <span class="text-danger">*</span></label>
                                    <input type="password" class="form-control input-sm" v-model="form.confirmPassword"
                                        required />
                                </div>
                            </div>

                        </div>
                        <div class="row mt-2" v-if="form.isADUser && !isUpdate">
                            <div class="col">
                                <div class="d-flex align-items-center gap-2">
                                    <input type="checkbox" id="driveFromPrincipleName" class="checkbox"
                                        v-model="form.driveFromPrincipleName">
                                    <label for="driveFromPrincipleName" class="mb-0">{{ $t('driveFromPrincipleName') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <div class="d-flex align-items-center gap-2">
                                    <input type="checkbox" id="active" class="checkbox" v-model="form.isActive">
                                    <label for="active" class="mb-0">{{ $t('active') }}</label>
                                </div>
                            </div>
                            <div class="col" v-if="isUpdate && !form.isADUser">
                                <div class="d-flex align-items-center gap-2">
                                    <input type="checkbox" id="resetPassword" class="checkbox" v-model="form.resetPassword">
                                    <label for="resetPassword" class="mb-0">{{ $t('Reset Password') }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="isUpdate && form.resetPassword">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('password') }} <span class="text-danger">*</span></label>
                                    <input type="password" class="form-control input-sm" v-model="form.password"
                                        :required="form.resetPassword" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{ $t('confirmPassword') }} <span class="text-danger">*</span></label>
                                    <input type="password" class="form-control input-sm" v-model="form.confirmPassword"
                                        :required="form.resetPassword" />
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <div class="d-flex align-items-center gap-2">
                                    <input type="checkbox" id="enableRenewTokenErrorAlert" class="checkbox"
                                        v-model="form.enableErrorAlert">
                                    <label for="enableRenewTokenErrorAlert" class="mb-0">{{ $t('enableRenewTokenErrorAlert') }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-outline-close" @click="close()">
                            <i class="fas fa-times"></i>&nbsp;{{ $t('close') }}
                        </button>
                        <button type="submit" class="btn btn-sm btn-outline-info-reverse">
                            <i class="fas fa-save"></i>&nbsp;{{ isUpdate ? $t('update') : $t('save') }}
                        </button>
                    </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script lang="ts" src="./User.Service.ts"></script>
